import { boot } from "../boot";

export function AuthProblemPage() {
  return (
    <>
      <h1>Вход</h1>
      <p className="lead">{boot.message}</p>
      <p><a className="button" href="/">На главную</a></p>
    </>
  );
}
